const styles = {
  global: {
    '*': { WebkitTapHighlightColor: 'transparent' },
    'img,svg': { userSelect: 'none' },
    'input,textarea': { outline: 'none' },

    'h1,h2,h3,h4': { m: '0px', p: '0px', lineHeight: '100%', letterSpacing: '0' },
    h1: { textStyle: 'h1' },
    h2: { textStyle: 'h2' },
    h3: { textStyle: 'h3' },
    h4: { textStyle: 'h4' },

    html: { minH: '100vh', bg: 'ourBlack', scrollBehavior: 'auto', overscrollBehavior: 'none' },
    body: {
      bgColor: 'ourBlack',
      color: 'deepBlue',
      minW: '100vw',
      position: 'relative',
      overflowX: 'hidden',
      overscrollBehavior: 'none',
      textTransform: 'none',
      boxSizing: 'border-box',
      zIndex: 1,

      '&::-webkit-scrollbar': { zIndex: 1, width: '10px', bgColor: 'transparent' },
      '&::-webkit-scrollbar-track': { zIndex: 1, width: '10px', bgColor: 'transparent' },
      '&::-webkit-scrollbar-thumb': { zIndex: 1, bgColor: 'ourGreen', borderRadius: '24px' },
    },
    '.grecaptcha-badge': { display: 'none !important' },
  },
};

export default styles;
